export const headerChanger = () => ({
    overflow: 'auto',
    marginBottom: '4rem',
    max992px: {
        marginBottom: '2.5rem',
    },
});
